import { pipe, multiply, round, add, subtract, curry } from 'lodash/fp';

const tenThousand = 10000;
const multiplyBy3 = multiply(3);
const fortyPercent = pipe(multiply(0.4), round);
const subtract10k = subtract(curry.placeholder, tenThousand);
const add10k = add(tenThousand);

// Total watts for appliances needed + 3 watts per sqft / 40% = watts needed
const calculateTotalWattsNeededWhenWholeHouse = ({
  squareFootage,
  partialPoweredApplianceWatts,
  alwaysPoweredApplianceWatts,
}) => {
  const addPartialPoweredApplianceWatts = add(partialPoweredApplianceWatts);
  const addAlwaysPoweredApplianceWatts = add(alwaysPoweredApplianceWatts);
  return pipe(
    multiplyBy3,
    addPartialPoweredApplianceWatts,
    subtract10k,
    fortyPercent,
    add10k,
    addAlwaysPoweredApplianceWatts,
  )(squareFootage);
};

export default calculateTotalWattsNeededWhenWholeHouse;



// WEBPACK FOOTER //
// ./src/views/Home/components/helpers/calculateTotalWattsNeeded.js